'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.onInitialClientRender = function () {
  if (process.env.NODE_ENV === 'production' && (typeof drift === 'undefined' ? 'undefined' : _typeof(drift)) === 'object' && window.driftAppId) {
    window.drift.SNIPPET_VERSION = '0.3.1';
    window.drift.load(window.driftAppId);
  }
};